import { createSelector } from 'reselect';

const selector = (state) => state.toJS().socialMediaReducer;

/**
 * Retrieves user state from user reducer
 */
export const influencersSelector = createSelector(
  selector,
  (socialMedia) => socialMedia.influencers.data,
);

/**
 * Retrieves user state from user reducer
 */
export const influencersCountSelector = createSelector(
  selector,
  (socialMedia) => socialMedia.influencers.count,
);

/**
 * Retrieves user state from user reducer
 */
export const influencersLoadingSelector = createSelector(
  selector,
  (socialMedia) => socialMedia.influencers.loading,
);

/**
 * Retrieves team state from influencer reducer
 */
export const teamSelector = createSelector(
  selector,
  (socialMedia) => socialMedia.team.data,
);

export default influencersSelector;
